import React, { useEffect } from "react";
import { Modal, Form, Input, Switch, notification } from "antd";
import {
  TaskStandAloneAlarm,
  useUpdateStandAloneAlarmMutation,
} from "shared/api";
import { getThemeColor } from "./taskHubHelpers";

interface EditTaskStandAloneAlarmModalProps {
  open: boolean;
  onClose: () => void;
  record: TaskStandAloneAlarm | null;
  refetch: () => void;
}

export const EditTaskStandAloneAlarmModal: React.FC<
  EditTaskStandAloneAlarmModalProps
> = ({ open, onClose, record, refetch }) => {
  const [api, contextHolder] = notification.useNotification();

  const [form] = Form.useForm();
  const [updateAlarm, { isLoading }] = useUpdateStandAloneAlarmMutation();

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        is_active: record.is_active,
        comments: record.comments,
      });
    }
  }, [record, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await updateAlarm({
        id: record?.id!,
        is_active: values.is_active,
        comments: values.comments,
      }).unwrap();

      refetch();
      onClose();

      api.success({
        message: "Task Updated",
        description: "The task was successfully updated.",
        placement: "topRight",
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Failed to update alarm", err);
    }
  };

  const themeColor = getThemeColor();

  return (
    <>
      {contextHolder}

      <Modal
        open={open}
        title="Edit Task Stand Alone Alarm"
        onCancel={onClose}
        onOk={handleSubmit}
        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: themeColor,
            color: "#fff",
            borderColor: themeColor,
          },
        }}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item label="Active" name="is_active" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Comments" name="comments">
            <Input.TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
